import type { ApiNabanBaseDocument, ApiNabanDeed } from '@izimi/api';

export const isNabanFodFinanceDocument = (
  document: ApiNabanBaseDocument,
): document is ApiNabanDeed['financeFeedbackDocuments'][number] => {
  return 'embeddedDocumentToken' in document && document.embeddedDocumentToken != null;
};

export const getMainDocumentFromDeed = ({ deed }: { deed?: ApiNabanDeed }) =>
  deed
    ? [...deed.financeDocuments, ...deed.financeFeedbackDocuments, ...deed.justiceDocuments].find(
        (document) => 'isMainMinute' in document,
      )
    : null;
